import { SignUp } from "@clerk/clerk-react";

export default function SignUpPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] px-4">
      <SignUp
        path="/sign-up"
        routing="path"
        signInUrl="/sign-in"
        signUpFallbackRedirectUrl="/dashboard/overview"
        appearance={{
          elements: {
            rootBox: "w-full max-w-md",
            card: "shadow-lg border border-zinc-100",
            headerTitle: "text-2xl font-bold font-sans",
            socialButtonsBlockButton: "bg-white border hover:bg-zinc-50",
            formButtonPrimary: "bg-[#0A0A0A] hover:bg-[#222]",
          },
          variables: {
            colorPrimary: "#0A0A0A",
            borderRadius: "0.5rem",
          },
        }}
      />
    </div>
  );
}
